module.exports = __webpack_public_path__ + "static/img/1692694601336.eb78fcc5.jpg";